import React from 'react';
import './Jumbotron.css';
import ReactCardCarousel from 'react-card-carousel';
import card1 from '../images/1.jpg';
import card2 from '../images/2.jpg';
import card3 from '../images/3.jpg';

class Jumbotron extends React.Component {
  render() {
    return (
      <div className="jumbotron jumbotron-fluid">
        <div className="caption">
          <h1>
            Bumi Pasundan Lahir<br></br> Ketika Tuhan Sedang Tersenyum
          </h1>
          <p>Ayo temukan surga tersembunyi di Garut | Swiss Van Java | Jawa Barat | Indonesia.</p>
          <a href="#Destination">
            <span>Kuy Liburan !</span>
          </a>
        </div>
        <div className="secCaption">
          <ReactCardCarousel autoplay={true} autoplay_speed={5000}>
            <div className="cardStyle">
              <img src={card1} className="img-fluid" alt="GunungSagara-@rbihsan" title="Gunung Sagara" />
              <small>GunungSagara - @rbihsan</small>
            </div>
            <div className="cardStyle">
              <img src={card2} className="img-fluid" alt="curugCikawung-unsplash@rizqi11_" title="Curug Cikawung" />
              <small>CurugCikawung - @rizqi11_</small>
            </div>
            <div className="cardStyle">
              <img src={card3} className="img-fluid" alt="Rancabango-unsplash@eyenuansa" title="Rancabango" />
              <small>Rancabango - @eyenuansa</small>
            </div>
          </ReactCardCarousel>
        </div>
      </div>
    );
  }
}

export default Jumbotron;
